<script setup lang="ts">
import type { ElementItem } from "@edco/apollo";
import type { BlockElement_media } from "~/models/generated/BlockElement_media";

defineProps<{
  content: ElementItem<BlockElement_media>;
  settings?: ElementItem;
}>();
</script>

<template>
  <figure class="editor-media">
    <NuxtImg
      :src="content.properties.media?.[0]?.url"
      alt=""
      role="presentation"
      class="editor-media__image" />

    <!--    <figcaption -->
    <!--      v-if="content.properties.caption" -->
    <!--      class="editor-media__caption"> -->
    <!--      {{ content.properties.caption }} -->
    <!--    </figcaption> -->
  </figure>
</template>

<style lang="scss" scoped>
.editor-media {
  &__image {
    max-width: 80%;
    padding-left: 50px;
    float: right;
  }

  &__image:not(:last-child) {
    margin-bottom: 5px;
  }

  &__caption {
    font-style: italic;
  }
}
</style>
